module.exports = ":host {\n  display: block;\n  float: left;\n  width: 50%;\n  height: 100%;\n  overflow: hidden; }\n\n.sub-navigation-panes-container {\n  display: inline-block;\n  width: 200%;\n  height: calc(100% - 4.5em);\n  overflow: hidden; }\n\n.sub-navigation-pane {\n  position: relative;\n  float: left;\n  width: 50%;\n  height: 100%; }\n\n.validation-button {\n  position: absolute;\n  bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-left-column/sub-navigation-container/sub-navigation-container.component.scss
// module id = ./src/app/main-left-column/sub-navigation-container/sub-navigation-container.component.scss
// module chunks = main